// extracted by mini-css-extract-plugin
module.exports =  {"content":"ChangeVersionDialog-module_content__dyEitmQ4lhlQF1kp0bLr","buttons":"ChangeVersionDialog-module_buttons__N0x0968evI6kbTro5mQl"};